/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';

const DisclaimersContainer = styled.div``;

export interface DisclaimersProps {
  disclaimers?: string[];
}

export const Disclaimers: React.FC<DisclaimersProps> = ({ disclaimers }) => {
  if (!disclaimers || !disclaimers.length) return null;

  return (
    <DisclaimersContainer>
      {disclaimers?.map((disclaimer, i) => (
        <Text
          key={`disclaimer${i}`}
          variant={{ type: 'copy', order: '3', style: 'normal' }}
          margin={['var(--spacing-relative-xs)', 0, 0, 0]}
        >
          {renderTextWithFootnotesReferencesV2(disclaimer)}
        </Text>
      ))}
    </DisclaimersContainer>
  );
};

Disclaimers.displayName = 'Disclaimers';
